export default __webpack_public_path__ + "static/media/verify-account-select-verification-method.3fc5f1a2.svg";